import saveAchievementRank from './triggers/saveAchievementRank'
import saveAchievementTask from './triggers/saveAchievementTask'
import saveNotification from './triggers/saveNotification'
import sendRiderMessage from './triggers/sendRiderMessage'
import processKyc from './triggers/processKyc'
import processRiderKyc from './triggers/processRiderKyc'
import processRestaurantKyc from './triggers/processRestaurantKyc'
import deleteKyc from './triggers/deleteKyc'
import deleteCustomer from './triggers/deleteCustomer'
import updateCustomerStatus from './triggers/updateCustomerStatus'
import updateWithdrawalStatus from './triggers/updateWithdrawalStatus'
import updateOrderStatus from './triggers/updateOrderStatus'
import updateStoreStatus from './triggers/updateStoreStatus'
import updateRestaurant from './triggers/updateRestaurant'
import updateRiderStatus from './triggers/updateRiderStatus'
import saveAccompaniement from './triggers/saveAccompaniement'
import acceptSponsorship from './triggers/acceptSponsorship'
import rejectSponsorship from './triggers/rejectSponsorship'
import blockSponsorship from './triggers/blockSponsorship'
import unblockSponsorship from './triggers/unblockSponsorship'
import updateSponsorship from './triggers/updateSponsorship'
import deleteSponsorship from './triggers/deleteSponsorship'
import { 
  createProduct, 
  updateProduct, 
  deleteProduct, 
  activateProduct, 
  deactivateProduct, 
  updatePurchaseStatus 
} from './triggers/productActions.js'


import updateTicket from './triggers/updateTicket'
import createTicket from './triggers/createTicket'
import addTicketMessage from './triggers/addTicketMessage'
import saveCoupon from './triggers/saveCoupon'
import saveAd from './triggers/saveAd'
import saveDeal from './triggers/saveDeal'
import saveFeesConfig from './triggers/saveFeesConfig'
import saveGeneralAppSettings from './triggers/saveGeneralAppSettings'
import updateBalances from './triggers/updateBalances'
import saveMilestone from './triggers/saveMilestone'
import deleteMilestone from './triggers/deleteMilestone'
import updatePromotionStatus from './triggers/updatePromotionStatus'
import saveRole from './triggers/saveRole'
import saveTeammate from './triggers/saveTeammate'
import updateStorePreferences from './triggers/updateStorePreferences'
import saveDish from './triggers/saveDish'
import createRestaurant from './triggers/createRestaurant'
import registerAdminUser from './triggers/registerAdminUser'
import updateAdminUser from './triggers/updateAdminUser'
import deleteAdminUser from './triggers/deleteAdminUser'
import deleteRole from './triggers/deleteRole'
import deleteTeammate from './triggers/deleteTeammate'
import saveLevel from './triggers/saveLevel'
import deleteLevel from './triggers/deleteLevel'
import saveRewardRule from './triggers/saveRewardRule'
import deleteRewardRule from './triggers/deleteRewardRule'

const data = {
  updateStorePreferences,
  saveDish,
  saveAchievementTask,
  saveAchievementRank,
  saveNotification,
  sendRiderMessage,
  processKyc,
  processRiderKyc,
  processRestaurantKyc,
  deleteKyc,
  deleteCustomer,
  updateCustomerStatus,
  updateWithdrawalStatus,
  updateOrderStatus,
  updateStoreStatus,
  updateRestaurant,
  updateRiderStatus,
  saveAccompaniement,

  updateTicket,
  createTicket,
  addTicketMessage,
  saveCoupon,
  saveAd,
  saveDeal,
  saveFeesConfig,
  saveGeneralAppSettings,
  updateBalances,
  saveMilestone,
  deleteMilestone,
  updatePromotionStatus,
  acceptSponsorship,
  rejectSponsorship,
  blockSponsorship,
  unblockSponsorship,
  updateSponsorship,
  deleteSponsorship,
  createProduct,
  updateProduct,
  deleteProduct,
  activateProduct,
  deactivateProduct,
  updatePurchaseStatus,
  saveRole,
  saveTeammate,
  createRestaurant,
  registerAdminUser,
  updateAdminUser,
  deleteAdminUser,
  deleteRole,
  deleteTeammate,
  saveLevel,
  deleteLevel,
  saveRewardRule,
  deleteRewardRule,
}


const actionSerializers = {}
const actionEndpoints = {}

Object.keys(data).forEach(key => {
  const item = data[key]

  const endpoint = {
    GET: item.getUrl || (() => ''),
    POST: item.postUrl || (() => ''),
    PUT: item.putUrl || (() => ''),
    PATCH: item.patchUrl || (() => ''),
    DELETE: item.deleteUrl || (() => ''),
  }


  // If a generic url function is provided, it should handle all methods
  if (item.url) {
    ;['GET', 'POST', 'PUT', 'PATCH', 'DELETE'].forEach(m => {
      endpoint[m] = item.url
    })
  }

  actionEndpoints[key] = endpoint

  class Serializer {
    get type() {
      return key
    }
    getPreferredMethod(payload) {
      if (typeof item.method === 'function') return item.method(payload).toLowerCase()
      return (item.method || 'post').toLowerCase()
    }
    deserialize(...args) {
      return item.parse(...args)
    }
    serialize(...args) {
      return item.format(...args)
    }
  }
  actionSerializers[key] = Serializer
})



export { actionSerializers, actionEndpoints }
